import { z } from 'zod';
import { dateSchema } from '@/model/utils';

export class SchoolGroup {
  constructor(
    public id: string,
    public name: string,
    public schoolIds: string[],
    public createdAt?: Date,
    public updatedAt?: Date
  ) {}

  public static zodSchema = z.object({
    id: z.string(),
    name: z.string(),
    schoolIds: z.array(z.string()),
    createdAt: dateSchema.optional(),
    updatedAt: dateSchema.optional(),
  });

  public static fromJson(json: unknown): SchoolGroup {
    const validJson = this.check(json);
    const schoolGroup = new SchoolGroup(
      validJson.id,
      validJson.name,
      validJson.schoolIds,
      validJson.createdAt,
      validJson.updatedAt
    );
    return schoolGroup;
  }

  public static fromJsonArray(jsonArray: unknown): SchoolGroup[] {
    const validJsonArray = this.checkArray(jsonArray);
    return validJsonArray.map(
      (json) => new SchoolGroup(json.id, json.name, json.schoolIds, json.createdAt, json.updatedAt)
    );
  }

  public static check(json: unknown): z.infer<typeof this.zodSchema> {
    return this.zodSchema.parse(json);
  }

  public static checkArray(jsonArray: unknown): z.infer<typeof this.zodSchema>[] {
    return z.array(this.zodSchema).parse(jsonArray);
  }
}
